import Icon from 'ui/Icon';
import { Box } from 'ui/Layout';
import Tooltip from 'ui/Tooltip';

type Props = {
  label: string;
};

const InfoTooltip: React.FC<Props> = ({ label }) => (
  <Tooltip content={label}>
    <Box cursor="help" display="inline-block" ml={1}>
      <Icon color="gray.600" icon="circle-info" fontSize="xs" />
    </Box>
  </Tooltip>
);

export default InfoTooltip;
